import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '~/root';
import { qk } from '~/root/query-keys';

type RequestId = number | string;

type RequestTokenPayload = {
  id: RequestId;
  token: string;
};

export const useCreateRequest = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, token }: RequestTokenPayload) =>
      axios.post(`/v1/requests/${id}/token/${token}`),
    onSuccess: () => {
      client.invalidateQueries(qk.init);
    },
  });
};

export const useResendRequest = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (id: RequestId) => axios.post(`/v1/requests/${id}/resend`),
    onSuccess: () => {
      client.invalidateQueries(qk.init);
    },
  });
};

export const useCancelRequest = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (id: RequestId) => axios.delete(`/v1/requests/${id}`),
    onSuccess: () => {
      client.invalidateQueries(qk.init);
    },
  });
};
